import React, { FC, useEffect } from 'react';
import { startAutoAdGuard } from 'config/ads';

/**
 * Mount once under the app shell to block AdSense Auto / vignette injectors.
 */
const AutoAdGuard: FC = () => {
  useEffect(() => {
    return startAutoAdGuard();
  }, []);
  return null;
};

export default AutoAdGuard;
